import { computed, ref } from 'vue';
import { ProviderType } from '../enums/provider-type';
import { Scholarship } from '@/presenters/scholarship';

export class ProviderFormField {
	public readonly provider = ref<ProviderType>();
	private _providerOrganisationId = ref<string | null>();
	private _providerBodyId = ref<string | null>();

	public providerOrganisationId = computed({
		get: () => {
			return this._providerOrganisationId?.value;
		},
		set: (value: string | null | undefined) => {
			this._providerOrganisationId.value = value;

			if (value) {
				this.providerBodyId.value = null;
			}
		},
	});

	public providerBodyId = computed({
		get: () => {
			return this._providerBodyId?.value;
		},
		set: (value: string | null | undefined) => {
			this._providerBodyId.value = value;

			if (value) {
				this._providerOrganisationId.value = null;
			}
		},
	});

	public isOrganisationProvider = (): boolean => this.provider.value === ProviderType.ORGANISATION;

	public isBodyProvider = (): boolean => this.provider.value === ProviderType.BODY;

	public updateFrom(scholarship: Scholarship): void {
		this.providerOrganisationId.value = scholarship.providerOrganisationId ?? undefined;
		this.providerBodyId.value = scholarship.providerBodyId ?? undefined;
		this.provider.value = scholarship.providerBodyId != null ? ProviderType.BODY : ProviderType.ORGANISATION;
	}
}
